

import {Component, EventEmitter, Input, OnInit, Output, ViewContainerRef,Injectable} from '@angular/core';
import {Dialog} from "../../../../../../shared/dialog/dialog";
import {ApiAdminCustomFieldService} from "../../../../../../services/api/admin/admin-custom-fields-api/admin-custom-fields-api.service";
import { HttpClient } from '@angular/common/http';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiAdminUsersService } from 'src/app/services/api/admin/admin-users-api/admin-users-api.service';
@Component({
  selector: 'app-admin-user-custom-fields-create-edit-dialog',
  templateUrl: './admin-user-custom-fields-create-edit-dialog.component.html'
})
@Injectable({
  providedIn: 'root'
})
export class AdminUserCustomFieldsComponentDialog implements Dialog {

  @Input() data; // {id: 122, requestTypeId: 12}
  @Output() remove = new EventEmitter<any>();

  isLoading = true;

  loadedId = null;

  loadedData;

  customFieldTypeOptions = [
    { id: 1,  name: 'Single Textbox'},
    { id: 2,  name: 'Multiple Choice'}
  ];

  selectedLevel1Id = null;
  selectedLevel2Id = null;
  selectedLevel3Id = null;

  addLevel1Value;
  addLevel2Value;
  addLevel3Value;

  constructor(
    private apiAdminCustomFieldService: ApiAdminCustomFieldService,
    private customFieldService: ApiAdminCustomFieldService,
    private apiAdminUsersService: ApiAdminUsersService
  ) {}


  ngOnInit(): void {

    if(this.data.id !== null){
      this.loadedId = this.data.id;
      this.getData();
    } else {

      // Load Default Data
      this.loadedData = {
        Name: ''
      }

      this.isLoading = false;

    }
  }

  filterOptions(level, parentOptionId){
    if (this.loadedData.Options === undefined) {
      return;
    }
    return this.loadedData.Options.filter(option => option.Level == level && option.ParentCustomFieldId == parentOptionId);
  }

  createOption(value, level, parentId){
    this.apiAdminUsersService.createCustomFieldOption(this.loadedId, value, level, parentId).then(response => {
      this.getData();
    })

    this.addLevel1Value = null;
    this.addLevel2Value = null;
    this.addLevel3Value = null;

  }

  deleteOption(optionId){
    this.apiAdminUsersService.deleteCustomFieldOption(this.loadedId, optionId).then(response => {
      this.getData();
    })
  }

  deleteSelectedOptions() {
    const selectedOptions = this.loadedData.Options.filter(option => option.selected);
    const deletePromises = selectedOptions.map(option =>
      this.apiAdminUsersService.deleteCustomFieldOption(this.loadedId, option.Id)
        .catch(error => {
          console.error(`Failed to delete option: ${error}`);
          return error; // Continue with other deletions even if one fails
          
        })
        
    );
  
    Promise.all(deletePromises).then(results => {
      console.log("Bulk delete results:", results);
      this.getData(); // Refresh data after operations
    });
  }
  moveOptionUp(optionId){
    this.apiAdminUsersService.moveUpCustomFieldOption(this.loadedId, optionId).then(response => {
      this.getData();
    })
  }




  moveOptionDown(optionId){
    this.apiAdminUsersService.moveDownCustomFieldOption(this.loadedId, optionId).then(response => {
      this.getData();
    })
  }

  getData(){
    this.isLoading = true;
    this.apiAdminUsersService.getCustomField(this.loadedId).then(response => {
      this.loadedData = response;
      this.isLoading = false;
    })
  }

  close(){
    this.remove.emit(null);
  }

  save(){
    if(this.loadedId){
      this.apiAdminUsersService.updateUserCustomField(this.loadedId, this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    } else {
      this.apiAdminUsersService.createCustomField(this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    }

  }
}
